import { ref, watch, onMounted } from "@vue/composition-api";

const SOLID = "solid";
const DOT = "dot";
const DEFAULT_NVALUE_TABLE_ROWS_COUNT = 2;

function filterNValueData(configRef, newNValuesData) {
  const { nValueTable } = configRef.value;

  if (nValueTable) {
    const { type } = nValueTable;
    let { rows } = nValueTable;

    if (type === 'regular') {
      if (rows == null) {
        rows = DEFAULT_NVALUE_TABLE_ROWS_COUNT;
      }

      return newNValuesData.length === rows
        ? newNValuesData
        : [];
    }

    if (type === 'show-all-series') {
      if (rows == null) {
        return newNValuesData;
      }

      return newNValuesData.slice(0, rows);
    }
  }

  return [];
}

export default function useLineChartDataSet(configRef, dataRef) {
  const lineChartDataSet = ref([]);
  const nValuesData = ref([]);

  const updateDataSet = () => {
    if (!dataRef?.value || !configRef?.value?.xAxis?.groups) {
      lineChartDataSet.value = [];
      nValuesData.value = [];
      return;
    }

    const { nValueTable } = configRef.value;

    const newLineChartDataSet = [];
    const newNValuesData = [];

    for (const group of dataRef.value) {
      for (const set of group.sets) {
        const setNValues = {
          label: set.nValueLabel,
          style: (set.line ?? SOLID) === SOLID ? SOLID : null,
          data: [],
        };

        for (const point of set.points) {
          newLineChartDataSet.push({
            groupName: group.name,
            groupColor: group.color,
            setName: set.name,
            setColor: set.color,
            setShape: set.shape ?? DOT,
            setLine: set.line ?? SOLID,
            ...point,
          });

          const value = !nValueTable?.sourceField
            ? point.nvalue ?? point.y
            : point[nValueTable.sourceField];

          setNValues.data.push(value);
        }

        newNValuesData.push(setNValues);
      }
    }

    lineChartDataSet.value = newLineChartDataSet;
    nValuesData.value = filterNValueData(configRef, newNValuesData);
  };

  watch([dataRef, configRef], updateDataSet);

  onMounted(updateDataSet);

  return { lineChartDataSet, nValuesData };
}
